
{
  "familyId": "GET-SCHATSTRATEGIE",
  "questions": [
    {
      "id": "GET-SCHATSTRATEGIE-001",
      "familyId": "GET-SCHATSTRATEGIE",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Je rekent 78 × 4. Welk antwoord kan NIET kloppen?",
      "options": [
        "3.120",
        "312",
        "292",
        "320"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatstrategie_controle",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Strategie: schat eerst het antwoord vóór je rekent. Stap 1: 78 ≈ 80. Stap 2: 80 × 4 = 320. Stap 3: het antwoord moet in de buurt van 320 liggen. Stap 4: 3.120 is veel te groot (bijna 10× te veel). Dat kan niet kloppen. (Het echte antwoord is 312.)",
        "distractorExplanations": {
          "0": "Goed! 3.120 is veel te groot. De schatting 80 × 4 = 320, dus het antwoord moet rond de 300 liggen, niet rond de 3.000.",
          "1": "312 is het juiste antwoord van 78 × 4. Dit klopt dus wel!",
          "2": "292 is dichtbij genoeg om te kunnen kloppen (verschil van 20 met het echte antwoord 312). Bij schatten zoek je de uitbijter.",
          "3": "320 is de schatting (80 × 4 = 320) en ligt dicht bij het echte antwoord (312). Dit kan dus kloppen."
        }
      }
    },
    {
      "id": "GET-SCHATSTRATEGIE-002",
      "familyId": "GET-SCHATSTRATEGIE",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Welke strategie gebruik je om 49 + 52 snel te schatten?",
      "options": [
        "50 + 50 = 100",
        "40 + 50 = 90",
        "49 + 50 = 99",
        "50 + 60 = 110"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatstrategie_afronden_beide",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: rond beide getallen af naar het dichtstbijzijnde tiental. Stap 1: 49 ≈ 50. Stap 2: 52 ≈ 50. Stap 3: 50 + 50 = 100. Het echte antwoord is 101, dus de schatting is heel nauwkeurig!",
        "distractorExplanations": {
          "0": "Goed! 50 + 50 = 100 is de handigste schatting. Beide getallen liggen dicht bij 50.",
          "1": "40 + 50 = 90 is te laag. 49 is dichter bij 50 dan bij 40. Rond altijd af naar het dichtstbijzijnde tiental.",
          "2": "49 + 50 = 99 klopt bijna, maar het doel van schatten is om met makkelijke getallen te werken. 50 + 50 is makkelijker dan 49 + 50.",
          "3": "50 + 60 = 110 is te hoog. 52 is dichter bij 50 dan bij 60."
        }
      }
    },
    {
      "id": "GET-SCHATSTRATEGIE-003",
      "familyId": "GET-SCHATSTRATEGIE",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Je koopt 3 boeken van €8,95. Hoeveel betaal je ongeveer?",
      "options": [
        "ongeveer €27",
        "ongeveer €24",
        "ongeveer €30",
        "ongeveer €9"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatstrategie_context_geld",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: rond af en reken dan. Stap 1: €8,95 ≈ €9 (bijna 9 euro). Stap 2: 3 × €9 = €27. Stap 3: het echte antwoord is 3 × €8,95 = €26,85, dus de schatting van €27 is heel goed!",
        "distractorExplanations": {
          "0": "Goed! 3 × €9 = €27. Door €8,95 af te ronden naar €9 krijg je een snelle en nauwkeurige schatting.",
          "1": "€24 is te laag. Dat zou kloppen als elk boek €8 kost (3 × 8 = 24), maar €8,95 is dichter bij €9 dan bij €8.",
          "2": "€30 is te hoog. Dat zou kloppen als elk boek €10 kost (3 × 10 = 30), maar €8,95 is dichter bij €9 dan bij €10.",
          "3": "€9 is de prijs van één boek, niet van drie. Je koopt 3 boeken, dus je moet vermenigvuldigen: 3 × €9 = €27."
        }
      }
    },
    {
      "id": "GET-SCHATSTRATEGIE-004",
      "familyId": "GET-SCHATSTRATEGIE",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Welk antwoord past het best bij 198 ÷ 4?",
      "options": [
        "ongeveer 50",
        "ongeveer 40",
        "ongeveer 200",
        "ongeveer 500"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatstrategie_deling",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Strategie: rond af naar een getal dat makkelijk deelbaar is. Stap 1: 198 ≈ 200 (dichtbij en deelbaar door 4). Stap 2: 200 ÷ 4 = 50. Stap 3: het echte antwoord is 49,5, dus de schatting van 50 is uitstekend!",
        "distractorExplanations": {
          "0": "Goed! 200 ÷ 4 = 50. Door 198 af te ronden naar 200 wordt de deling makkelijk.",
          "1": "40 is te laag. 4 × 40 = 160, maar 198 is veel meer dan 160.",
          "2": "200 is het getal dat je deelt, niet het antwoord. 198 ÷ 4 ≈ 50, niet 200.",
          "3": "500 is veel te hoog. 4 × 500 = 2.000, maar we delen 198, niet 2.000."
        }
      }
    },
    {
      "id": "GET-SCHATSTRATEGIE-005",
      "familyId": "GET-SCHATSTRATEGIE",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "bewerkingen",
      "subSkill": "schatstrategie",
      "questionType": "multiple_choice",
      "question": "Lotte rekent 623 − 187. Ze krijgt __(antwoord)__. Welke schatting helpt haar controleren?",
      "options": [
        "600 − 200 = 400",
        "600 − 100 = 500",
        "700 − 200 = 500",
        "620 − 190 = 430"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "schatstrategie_controle_aftrekking",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Strategie: rond beide getallen af op honderdtallen voor een snelle controle. Stap 1: 623 ≈ 600. Stap 2: 187 ≈ 200. Stap 3: 600 − 200 = 400. Het echte antwoord is 436, dus als Lotte iets rond de 400 krijgt, klopt het waarschijnlijk.",
        "distractorExplanations": {
          "0": "Goed! 600 − 200 = 400 is de handigste schatting. Beide getallen zijn afgerond op honderdtallen.",
          "1": "600 − 100 = 500 is te hoog. 187 is dichter bij 200 dan bij 100 (het tientallencijfer 8 ≥ 5).",
          "2": "700 − 200 = 500 is te hoog. 623 is dichter bij 600 dan bij 700.",
          "3": "620 − 190 = 430 is nauwkeuriger, maar moeilijker uit het hoofd te rekenen. Bij schatten kies je de makkelijkste getallen."
        }
      }
    }
  ]
}
